const root = `td-punish//`
const urls = {
  queryLinkAndProcessWarn: root + 'warnTimeout' + '/list'
}
// 查询你预警超时
export const queryLinkAndProcessWarn = obj => {
  return $http.get(urls.queryLinkAndProcessWarn, obj)
}
export default {
  queryLinkAndProcessWarn
}
